import { render, staticRenderFns } from "./company-create-step-info.vue?vue&type=template&id=c04c5eee&scoped=true&"
import script from "./company-create-step-info.vue?vue&type=script&lang=js&"
export * from "./company-create-step-info.vue?vue&type=script&lang=js&"
import style0 from "./company-create-step-info.vue?vue&type=style&index=0&id=c04c5eee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04c5eee",
  null
  
)

export default component.exports